const shadows = {
  shadowMd:
    "0 4px 8px -2px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.06)",
};

export default shadows;
